import { Outlet } from 'react-router-dom';
import { useSidebar } from '@/context/SidebarContext';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';
import { ErrorBoundary } from '@/components/ui/ErrorBoundary';

function DashboardContent() {
    const { isOpen } = useSidebar();

    return (
        <div className="flex h-[calc(100vh-64px)] bg-background overflow-hidden relative">
            <Sidebar />
            <div
                className={`flex-1 transition-all duration-300 ease-in-out flex flex-col h-full ${isOpen ? 'md:ml-64' : 'md:ml-20'
                    }`}
            >
                {/* Scrollable Content Area */}
                <div className="flex-1 overflow-y-auto p-6 md:p-8">
                    <div className="w-full animate-in fade-in slide-in-from-bottom-4 duration-500 h-full">
                        <ErrorBoundary>
                            <Outlet />
                        </ErrorBoundary>
                    </div>
                </div>

                {/* Static Footer */}
                <div className="sticky bottom-0 z-10 hidden md:block">
                    <Footer />
                </div>
            </div>
        </div>
    );
}

export function DashboardLayout() {
    return (
        <DashboardContent />
    );
}
